const CONFIG = {
    API_URL: (() => {
        if (process.env.REACT_APP_API_URL) {
            return process.env.REACT_APP_API_URL;
        }
        // In development, we want to use the tunnel profile API URL or localhost:5000
        if (window.location.hostname === 'localhost') {
            return process.env.TUNNEL_PROFILE_API_URL || 'http://localhost:5000';
        }
        // In production, we assume the API is on the same origin as the client
        return window.location.origin;
    })()
};
export default CONFIG;













// const CONFIG = {
//     API_URL: (() => {
//         if (process.env.REACT_APP_API_URL) {
//             return process.env.REACT_APP_API_URL;
//         }
//         const urlMap = {
//             localhost: process.env.TUNNEL_PROFILE_API_URL || 'http://localhost:5000',
//             profile: process.env.TUNNEL_PROFILE_API_URL || 'http://profile-api:5000',
//             production: process.env.TUNNEL_PRODUCTION_API_URL || 'https://api.example.com'
//         };
//         return urlMap[window.location.hostname] || '';
//     })()
// };
// export default CONFIG;





// // // const CONFIG = {
// // //     API_URL: process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000' : '')
// // // };

// // // export default CONFIG;

// // // const CONFIG = {
// // //     API_URL: process.env.REACT_APP_API_URL || "http://localhost:5000"
// // // };

// // // export default CONFIG;

// // const CONFIG = {
// //     API_URL: process.env.REACT_APP_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000' : '')
// // };

// // export default CONFIG;